import type { PositionRow } from '@/components/finest-custom-position-list/types'
import type { AmountUnit } from '@/utils/amount-unit'
import LoanType = App.Enums.FinancingRequest.LoanType

export interface FinancingDraft {
  purchase_price: number | null
  land_register_charge: number | null
  land_register_charge_unit: AmountUnit
  broker_commission: number | null
  broker_commission_unit: AmountUnit
  notary_land_registry_fees: number | null
  notary_land_registry_fees_unit: AmountUnit
  equity: number | null
  modernizations: PositionRow[]
  loan_type: LoanType | null
  total_financing_amount: number | null
  interest_term_years: number | null
  repayment_rate: number | null
}

export interface ModernizationPayload {
  type: string
  price: number | null
}

export const emptyFinancingDraft = (): FinancingDraft => ({
  purchase_price: null,
  land_register_charge: null,
  land_register_charge_unit: 'percent',
  broker_commission: null,
  broker_commission_unit: 'percent',
  notary_land_registry_fees: null,
  notary_land_registry_fees_unit: 'percent',
  equity: null,
  modernizations: [],
  loan_type: null,
  total_financing_amount: null,
  interest_term_years: null,
  repayment_rate: null,
})

export const isFinancingComplete = (draft: FinancingDraft): boolean =>
  draft.purchase_price !== null &&
  draft.land_register_charge !== null &&
  draft.notary_land_registry_fees !== null &&
  draft.equity !== null &&
  draft.loan_type !== null &&
  draft.total_financing_amount !== null &&
  draft.repayment_rate !== null &&
  (draft.loan_type === 'variable' || draft.interest_term_years !== null)

const chosenType = (value: unknown): string | null => (typeof value === 'string' && value !== '' ? value : null)

/** The wizard has no property to attach measures to yet, so the rows travel with the submission. */
export const modernizationPayload = (rows: PositionRow[]): ModernizationPayload[] =>
  rows
    .map((row) => ({
      type: chosenType(row.cells.type),
      price: typeof row.cells.price === 'number' ? row.cells.price : null,
    }))
    .filter((entry): entry is ModernizationPayload => entry.type !== null)
